export const FETCH_NEWSPAPERS = "fetchNewspapers";
export const FETCH_LAST = "fetchLast";
export const FETCH_NEWSPAPERINFO = "fetchNewspaperInfo";
export const FETCH_NEWS = "fetchNews";
export const FETCH_NEWSINFO = "fetchNewsinfo";
export const FETCH_CAT = "fetchCat";
export const ADD_COMMENT = "addComment";
export const RESET_CONFIG = "resetConfig";
export const UPDATESET_CONFIG = "updateSetConfig";

